import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Sunrise } from "lucide-react";
import { getMaturedUnread } from "@/lib/lettersVault";
import { WELCOME_BANNER } from "@/constants/testIds";

/**
 * LettersBanner — appears on Welcome when one or more tomorrow-you letters
 * have arrived. Tone: gentle, never urgent. The letter itself stays sealed
 * and encrypted until the user opens it.
 */
export default function LettersBanner() {
  const nav = useNavigate();
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    getMaturedUnread()
      .then((arr) => {
        if (!cancelled) setCount(arr.length);
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, []);

  if (count <= 0) return null;

  return (
    <motion.button
      data-testid={WELCOME_BANNER.letters}
      onClick={() => nav("/letters")}
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.15 }}
      className="relative w-full overflow-hidden rounded-3xl p-4 mb-5 text-left un-press"
      style={{
        background:
          "linear-gradient(135deg, #F3E9DF 0%, #F0E5D1 65%, #EBE5D9 100%)",
        boxShadow: "0 8px 26px rgba(74,32,64,0.08)",
      }}
    >
      <div className="flex items-start gap-3">
        <Sunrise
          size={18}
          className="mt-0.5 shrink-0"
          style={{ color: "var(--un-terracotta)" }}
        />
        <div>
          <p
            className="text-[14px] font-medium leading-snug"
            style={{
              color: "var(--un-text-1)",
              fontFamily: "Manrope, sans-serif",
            }}
          >
            {count === 1
              ? "A letter from a past you arrived."
              : `${count} letters from a past you arrived.`}
          </p>
          <p
            className="text-[15px] italic mt-0.5"
            style={{
              color: "var(--un-text-2)",
              fontFamily: "Cormorant Garamond, serif",
            }}
          >
            Tap when you're ready. There's no rush.
          </p>
        </div>
      </div>
    </motion.button>
  );
}
